import TimezoneList from './TimezoneList.component';

export default TimezoneList;
